import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document, BLOCKS, Node } from '@contentful/rich-text-types'
import Image from 'components/image'

import { TypePostEmbedImageFields } from 'hello_baby/types/guides'

import EmbedSocialMedia from '../Embeds/EmbedSocialMedia'
import EmbedImage from '../Embeds/EmbedImage'

import css from './styles.scss'

interface RichTextBodyProps {
  richTextBody: Document
  serverData: ServerData | undefined
}

const RichTextBody: React.FC<RichTextBodyProps> = ({
  richTextBody,
  serverData,
}: RichTextBodyProps) => {
  const renderVideo = (node: Node) => {
    const url = new URL(node.data.target.fields?.url)
    let videoId = url.searchParams.get('v')

    if (!videoId) {
      const pathParts = url.pathname.split('/')
      videoId = pathParts[pathParts.length - 1]
    }

    return (
      <div className={css.Embed__Youtube}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?feature=oembed&modestbranding=1&showinfo=0&rel=0&controls=1`}
          title={node.data.target.fields?.title || ''}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    )
  }

  const renderSocialMedia = (node: Node) => (
    <EmbedSocialMedia
      channel={node.data.target.fields?.channel}
      embedCode={node.data.target.fields?.embedCode}
    />
  )

  const handlePrerenderedEmbed = (id: string) => {
    if (!serverData || !serverData.embeddedEntries) {
      return null
    }

    const item = serverData.embeddedEntries.find((i) => i.id === id)
    if (item) {
      // eslint-disable-next-line react/no-danger
      return <div dangerouslySetInnerHTML={{ __html: item.html }} />
    }
    return null
  }

  const renderEmbeddedEntry = (node: Node) => {
    const id = node.data.target?.sys?.id
    if (!id) return null

    const type = node.data.target.sys?.contentType?.sys?.id as
      | string
      | undefined

    switch (type) {
      case 'video':
        return renderVideo(node)
      case 'postEmbedSocialMedia':
        return renderSocialMedia(node)
      case 'postEmbedImage':
        if (!node.data.target.fields || !node.data.target.fields.image)
          return null
        return (
          <EmbedImage
            fields={node.data.target.fields as TypePostEmbedImageFields}
          />
        )
      default:
        return handlePrerenderedEmbed(id)
    }
  }

  const richTextOptions = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node: Node) => {
        try {
          return renderEmbeddedEntry(node)
        } catch (e) {
          console.log(e)
        }
        return null
      },
      [BLOCKS.EMBEDDED_ASSET]: (node: Node) => {
        try {
          if (!node.data.target.fields) return null
          const { url, description } = node.data.target.fields
          return (
            <Image
              alt={description}
              className="img-responsive"
              src={url}
              style={{ maxWidth: '100%' }}
            />
          )
        } catch (e) {
          console.log(e)
          return null
        }
      },
    },
  }
  return <>{documentToReactComponents(richTextBody, richTextOptions)}</>
}

export default RichTextBody
